import { has, isNil, is, isEmpty } from "ramda";
import messages from "application/messages";
import { replace, split } from "ramda";

export default function translate(key, locale) {
  if (isNil(key) || !is(String, key) || isEmpty(key)) {
    return "";
  }

  const lang = navigator.language || navigator.userLanguage;
  const appLocale = replace("-", "_", lang.toLowerCase());

  if (!isEmpty(getTranslation(appLocale, key))) {
    return getTranslation(appLocale, key);
  }

  const splittedLocale =
    appLocale !== "nl_be" ? split("_", appLocale)[0] : "nl_be";

  if (!isEmpty(getTranslation(splittedLocale, key))) {
    return getTranslation(splittedLocale, key);
  }

  if (!isEmpty(getTranslation("en", key))) {
    return getTranslation("en", key);
  }

  return key;
}

function getTranslation(locale, key) {
  if (has(locale, messages)) {
    const translations = messages[locale];
    if (has(key, translations)) {
      const result = translations[key];
      return result;
    }
  }
  return "";
}
